import PrimaryLocationsDropdown from './PrimaryLocationsDropdown';

export default PrimaryLocationsDropdown;
